import ManageReportPage from './ManageReportPage';

export default ManageReportPage;
export { default as reducer } from './report.ducks';



// WEBPACK FOOTER //
// ./src/routes/Admin/ManageReportPage/index.ts